import { Component, input } from '@angular/core';

// One icon, one place. Bootstrap Icons, rendered as the `bi bi-{name}` span the font
// expects, always `aria-hidden` - the button or link around it carries the label, so
// the icon must not be read out twice.
//
// ⚠️ Why a component rather than writing `<i class="bi bi-x">` inline (Chris, PR 2348,
// 2026-09-24): the convention is then in ONE file. Changing icon set, adding a size or
// fixing the accessibility rule is one edit instead of forty, and a screen cannot
// quietly spell a class wrong - a mistyped `bi-` name renders NOTHING, with no error.
//
// ⚠️ A text character is never an icon. `×` `▶` `⌫` look like icons in a Latin font and
// are read aloud as "times", "black right-pointing triangle" and "erase to the left" by
// a screen reader, and they shift with the font.
//
// ⚠️ **The consuming app must load the Bootstrap Icons font** - an angular.json `styles`
// entry for `node_modules/bootstrap-icons/font/bootstrap-icons.min.css`. Without it every
// icon renders BLANK, with no error; TmsAdmin was in exactly that state until 2026-09-24.
// Today only the Workbench-shaped apps (TmsWorkbench, TmsAdmin) load it: **TmsWeb, the
// portal and the scanners are Font Awesome 5 apps** (`fa fa-` from a CDN, see ui.md), so
// this component is available to them but not drop-in - adopting it there means adding
// the font, and the names differ between the two sets.
// It lives here rather than in tms-workbench-ui so any app CAN reuse it (Chris, 2026-09-24).
@Component({
  selector: 'app-icon',
  template: `<span [class]="'bi bi-' + name()" aria-hidden="true"></span>`,
  styleUrl: './icon.component.scss',
})
export class IconComponent {
  // The Bootstrap Icons name WITHOUT the `bi-` prefix, e.g. "x", "play-fill".
  public readonly name = input.required<string>();
}
